import Actions from '@app/store/action';
import Store from '@app/store';

import Analytics from '@module/analytics';

export const shouldAskBeforeLeaving = (route, transfer) =>
  route.unSavedForm ||
  (route.isMobileTransfer && !!(transfer.files || transfer.items).length);

export function createOnRouteHandler(router) {
  return function handleOnRoute(route) {
    const { user } = Store.getState();

    if (
      typeof route.shouldRedirect === 'function' &&
      typeof route.redirectTo === 'function' &&
      route.shouldRedirect(user)
    ) {
      route.redirectTo(router, route.path, user);
      return;
    }

    // Record referral key for acqusition channel tracking
    Analytics.setReferralKey(location.search);

    // Record page view
    Analytics.trackPageView(route.path + location.search);

    // Update the Route in our store.
    Store.dispatch(Actions.Route.setRoute(route));
  };
}
